import styled from 'styled-components';

export const Box = styled.div`
  margin-bottom: 30px;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;
